import type { JSX, ReactNode } from 'react';
import type { Palette } from '../_theme/palette.js';
import { Button } from './Button.js';
import { ArrowLeftIcon, ArrowRightIcon } from './Icons.js';
import { SubmitButton } from './SubmitButton.js';

interface WizardFooterProps {
  palette: Palette;
  onBack?: () => void;
  onNext: () => void;
  canGoBack: boolean;
  isLast: boolean;
  submitting?: boolean;
  submitLabel?: string;
  nextLabel?: string;
  centerSlot?: ReactNode;
}

export function WizardFooter({
  palette,
  onBack,
  onNext,
  canGoBack,
  isLast,
  submitting = false,
  submitLabel = 'Submit',
  nextLabel = 'Next',
  centerSlot,
}: WizardFooterProps): JSX.Element {
  const primaryLabel = isLast ? submitLabel : nextLabel;

  return (
    <div
      className="chirp-survey-footer"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 32px',
        borderTop: `1px solid ${palette.border}`,
        background: palette.card,
        gap: 10,
      }}
    >
      {canGoBack && onBack ? (
        <Button
          palette={palette}
          variant="secondary"
          onClick={onBack}
          disabled={submitting}
          leadingIcon={<ArrowLeftIcon />}
        >
          Back
        </Button>
      ) : (
        <span />
      )}
      {centerSlot ?? <span />}
      <SubmitButton
        palette={palette}
        onClick={onNext}
        submitting={submitting}
        trailingIcon={<ArrowRightIcon />}
      >
        {primaryLabel}
      </SubmitButton>
    </div>
  );
}
